<template>
    <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-10 col-md-11">
              <h5 class="card-title">{{ $t('popularVotes.title') }}</h5>
            </div>
          </div>
          <hr class="mt-0 mb-2">
          <div class="row">
            <div class="col-12 text-left build-next">
              {{ $t('popularVotes.buildNext') }}
            </div>
          </div>
          <div class="row flex-nowrap vote-options pt-4"
            v-show="surveyOptions.length > 0 && !loading && !sending"
            v-on:scroll="updateScrollPosition">
            <div v-if="hideNext && hNext" class="next" @click="next">
              <img src="img/icons/back.svg" alt="arrow" width="23">
            </div>
            <div v-if="hideBack || hBack" class="back" @click="back">
              <img src="img/icons/back.svg" alt="arrow" width="23">
            </div>
            <div class="col-6" v-for="option in surveyOptions" :key="option.value">
              <div class="row pl-2 pr-2">
                <div class="col-12 text-left option-label w-100">
                  {{ option.text }}
                </div>
              </div>
              <div class="row pt-3" v-if="!isDisabled">
                <div class="col-12 offset-md-1 col-md-5" v-if="voted(option.value)">
                  <div class="row">
                    <div class="col-12 text-center for-text">
                      {{ $t('popularVotes.voteFor') }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      {{ result(option.value).for }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-5" v-if="voted(option.value)">
                  <div class="row">
                    <div class="col-12 text-center against-text">
                      {{ $t('popularVotes.voteAgainst') }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      {{ result(option.value).against }}
                    </div>
                  </div>
                </div>
                <div class="col-12 offset-md-1 col-md-5" v-if="!voted(option.value)">
                  <button type="button"
                    class="btn for w-100 h-100"
                    @click="vote(option.value, true)"
                    :disabled="isDisabled">
                    {{ $t('popularVotes.for') }}
                  </button>
                </div>
                <div class="col-12 col-md-5" v-if="!voted(option.value)">
                  <button type="button"
                    class="btn against w-100 h-100"
                    @click="vote(option.value, false)"
                    :disabled="isDisabled">
                    {{ $t('popularVotes.against') }}
                  </button>
                </div>
              </div>
              <div class="row pt-3" v-if="isDisabled">
                <div class="col-12 offset-md-1 col-md-5 text-center for-text">
                  {{ $t('popularVotes.voteFor') }}
                </div>
                <div class="col-12 col-md-5 text-center against-text">
                   {{ $t('popularVotes.voteAgainst') }}
                </div>
              </div>
              <div class="row pt-3" v-if="isDisabled && result(option.value)">
                <div class="col-12 offset-md-1 col-md-5 text-center">
                  {{ result(option.value).for }}
                </div>
                <div class="col-12 col-md-5 text-center">
                   {{ result(option.value).against }}
                </div>
              </div>
            </div>
          </div>
          <div class="no-items" v-if="surveyOptions.length == 0 && !loading && !sending">
            <div class="row h-100">
              <div class="col-md-12 d-flex align-items-center justify-content-center">
                <h5>{{ $t('popularVotes.noItems') }}</h5>
              </div>
            </div>
          </div>
          <div class="no-items" v-show="loading">
            <div class="row h-100">
              <div class="col-md-12 d-flex align-items-center justify-content-center">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
            </div>
          </div>
          <div class="no-items" v-show="sending">
            <div class="row h-100">
              <div class="col-md-12 d-flex align-items-center justify-content-center">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
              <div class="col-md-12 pt-1 text-center">
                <h6>{{ $t('general.sending') }}</h6>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'

export default {
  computed: {
    votesRemaining() {
      return this.$store.getters.getAmountStakedByUser
    },
    surveyOptions () {
      return this.$store.getters.getSurveyOptions
    },
    endDate () {
      const endDateTimeStamp = this.$store.getters.getEndDate

      return new Date(endDateTimeStamp * 1000)
    },
    isDisabled () {
      return !this.$store.getters.getIsConnected
    },
    currentAccount () {
      return this.$store.getters.getAddress
    },
    votedOptions () {
      return this.$store.getters.getVotedOptions
    },
    results () {
      return this.$store.getters.getSurveyResults
    },
    stakeStatus () {
      return this.$store.getters.getStakeStatus
    },
    surveyName () {
      return this.$store.getters.getSurveyName
    }
  },
  data () {
    return {
      timeLeft: '0 days 0 minutes',
      loading: true,
      sending: false,
      hideBack: false,
      hideNext: true,
      hBack: false,
      hNext: true
    }
  },
  methods: {
    calculateTimeLeft () {
      const now = new Date().getTime()

      if (new Date() > this.endDate) {
        this.timeLeft = this.$t('popularVotes.timeLeft', { days: 0, hours: 0, minutes: 0 })
      } else {
        const distance = this.endDate - now
        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        
        this.timeLeft = this.$t('popularVotes.timeLeft', { days: days, hours: hours, minutes: minutes })
      }
    },
    async vote (option, typeVote) {
      let now = new Date()

      await this.$store.dispatch('getStakingInfo', this.currentAccount)
      await this.$store.dispatch('getAmountStakedByUser', this.currentAccount)

      if (this.stakeStatus) {
        if (this.endDate >= now) {
          if (this.votesRemaining > 0.001) {
            this.sending = true

            try {
              await this.$store.dispatch('saveAnswer', {
                option: option,
                typeVote: typeVote,
                address: this.currentAccount
              })

              this.$store.dispatch('getBalance', this.currentAccount)

              await this.$store.dispatch('getSurveyResult')

              await this.$store.dispatch('getVotedOptions', this.currentAccount)

              this.sending = false

              Swal.fire({
                title: 'Success',
                text: 'Vote registered successfully',
                icon: 'success',
                confirmButtonText: 'Ok'
              })

              this.next()
            } catch (error) {
              this.sending = false
            }
          } else {
            Swal.fire({
              title: 'Error',
              text: "Insufficient AHT. You need to staking more",
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }
        } else {
          Swal.fire({
            title: 'Error',
            text: 'Survey closed',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        } 
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Staking inactive',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    },
    voted (option) {
      return this.votedOptions.includes(option)
    },
    result (option) {
      const optionResult = this.results.find(element => element.option == option)

      return optionResult
    },
    next () {
      this.hideBack = true
      let content = document.querySelector(".vote-options")
      content.scrollLeft += content.offsetWidth / 2

      if (content.scrollLeft + content.offsetWidth + (content.offsetWidth / 2) < content.scrollWidth) {
        this.hideNext = true
      } else {
        this.hideNext = false
      }
    },
    back () {
      this.hideNext = true
      let content = document.querySelector(".vote-options")
      content.scrollLeft -= content.offsetWidth / 2

      if (content.scrollLeft - (content.offsetWidth / 2) > 0) {
        this.hideBack = true
      } else {
        this.hideBack = false
      }
    },
    updateScrollPosition () {
      this.chBack()
      this.chNext()
    },
    chBack () {
      let content = document.querySelector(".vote-options")

      this.hBack = content.scrollLeft - 1 > 0 ? true : false
    },
    chNext () {
      let content = document.querySelector(".vote-options")
      
      this.hNext = content.scrollLeft !== content.scrollWidth - content.offsetWidth
    }
  },
  async mounted () {
    const self = this
    this.loading = false

    setInterval(() => {
      self.calculateTimeLeft()
    }, 60000)
  },
  watch: {
    endDate: function (val) {
      this.calculateTimeLeft()
    },
    currentAccount: async function (val) {
      if (val)
        await this.$store.dispatch('getVotedOptions', this.currentAccount)
    },
    async surveyName () {
      await this.$store.dispatch('getSurveyOptions')
      await this.$store.dispatch('getSurveyResult')
    }
  }
}
</script>

<style scoped>
.card {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
}

.build-next {
  text-align: left;
  font: normal normal normal 16px Poppins;
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.vote-options {
  overflow-x: auto;
  height: 235px;
  scroll-behavior: smooth;
}

.option-label {
  background: #131419 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  font: normal normal normal 15px/15px Poppins;
  letter-spacing: 0px;
  color: #fff;
  height: 7rem;
  padding-top: 2.5rem;
}

.no-items {
  height: 240px;
  max-height: 240px;
  text-align: center;
}

.card-title {
  font-size: 17px;
}

.back {
  position: fixed;
  z-index: 2;
  transform: rotate(-180deg);
  background: #1F2425 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 25px #0000000D;
  border-radius: 50px;
  opacity: 1;
  padding-left: .3rem;
  padding-right: .3rem;
  left: -6px;
  top: 10.5rem;
  cursor: pointer;
}

.next {
  position: fixed;
  z-index: 2;
  background: #1F2425 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 25px #0000000D;
  border-radius: 50px;
  opacity: 1;
  padding-left: .3rem;
  padding-right: .3rem;
  right: -5px;
  top: 10.5rem;
  cursor: pointer;
}

.for-text {
  color: #61c9d9;
  font-size: .7rem;
}

.against-text {
  color: #ff5e62;
  font-size: .7rem;
}

.for {
  background: #61c9d9 0% 0% no-repeat padding-box;
  border-radius: 30px;
  color: #fff;
  font: normal normal 600 12px/15px Poppins;
  letter-spacing: 0px;
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.against {
  border: 1px solid #ff5e62;
  border-radius: 30px;
  color: #ff5e62;
  font: normal normal 600 12px/15px Poppins;
  letter-spacing: 0px;
  padding-top: .5rem;
  padding-bottom: .5rem;
}
</style>
